import { Injectable } from '@angular/core';
import { CompanyDataService } from './company-data.service';

@Injectable()
export class AppInitService {

  constructor(private companyDataService: CompanyDataService) {}

  /**
   * Initialize app data - load company data at startup
   */
  init(): Promise<void> {
    return new Promise((resolve) => {
      this.companyDataService.getCompanyData().subscribe(
        () => {
          console.log('Company data loaded successfully at app startup');
          resolve();
        },
        (error) => {
          console.error('Failed to load company data at app startup:', error);
          // Don't reject the promise - let the app start even if company data fails
          // The components will handle the error gracefully
          resolve();
        },
      );
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/@core/services/app-init.service.ts